import { z } from 'zod'
import {
  FacebookPixelFieldsSchema,
  GoogleAdsPixelFieldsSchema,
  PixelProviderSchema,
  TiktokPixelFieldsSchema,
  UtmifyPixelFieldsSchema,
} from '@shared/contracts/pixels'

export const AffiliationStatusSchema = z.enum(['PENDENTE', 'APROVADO', 'RECUSADO', 'BLOQUEADO'])
export type AffiliationStatus = z.infer<typeof AffiliationStatusSchema>

export const AffiliationProductSchema = z.object({
  name: z.string(),
  productType: z.string().optional(),
  coverImage: z.string().optional(),
  promotionLinks: z
    .array(
      z.object({
        checkoutId: z.string(),
        label: z.string(),
      }),
    )
    .optional(),
})
export type AffiliationProduct = z.infer<typeof AffiliationProductSchema>

export const AffiliationUserSchema = z.object({
  email: z.string(),
})
export type AffiliationUser = z.infer<typeof AffiliationUserSchema>

export const AffiliationSchema = z.object({
  id: z.string(),
  productId: z.string(),
  affiliateId: z.string(),
  commissionPercentage: z.string(),
  status: AffiliationStatusSchema,
  product: AffiliationProductSchema.optional(),
  affiliate: AffiliationUserSchema.optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type Affiliation = z.infer<typeof AffiliationSchema>

export const AffiliatePixelProviderSchema = PixelProviderSchema
export type AffiliatePixelProvider = z.infer<typeof AffiliatePixelProviderSchema>

const affiliatePixelFields = {
  id: z.string(),
  sendOnlyCommission: z.literal(true).catch(true),
}

export const AffiliatePixelSchema = z.discriminatedUnion('provider', [
  FacebookPixelFieldsSchema.extend(affiliatePixelFields),
  TiktokPixelFieldsSchema.extend(affiliatePixelFields),
  GoogleAdsPixelFieldsSchema.extend(affiliatePixelFields),
  UtmifyPixelFieldsSchema.extend(affiliatePixelFields),
])
export type AffiliatePixel = z.infer<typeof AffiliatePixelSchema>

export const MarketplaceProductSchema = z.object({
  id: z.string(),
  name: z.string(),
  productType: z.string(),
  category: z.string(),
  coverImage: z.string(),
  comissaoAfiliado: z.string().optional(),
})
export type MarketplaceProduct = z.infer<typeof MarketplaceProductSchema>

const affiliationStatusLabels: Record<AffiliationStatus, string> = {
  PENDENTE: 'Aguardando aprovação',
  APROVADO: 'Afiliação aprovada',
  RECUSADO: 'Recusada',
  BLOQUEADO: 'Bloqueada',
}

export function affiliationStatusLabel(status: AffiliationStatus) {
  return affiliationStatusLabels[status]
}

export function percentageLabel(value: string) {
  const numeric = Number(value)
  return Number.isFinite(numeric) ? `${numeric}%` : `${value}%`
}

export function inviteTokenFromInput(value: string) {
  return (
    value
      .trim()
      .split(/[/\s]+/)
      .filter(Boolean)
      .pop() ?? ''
  )
}
